import isSSR from '../isSSR'
import { COOKIE_NAME_TO_ACTIVE_NEW_LOGIN } from './constants'

export const isNewLoginActive = (): boolean => {
  if (isSSR()) return false

  const cookieValue = Number(
    window?.getCookie?.(COOKIE_NAME_TO_ACTIVE_NEW_LOGIN)
  )

  return cookieValue === 1
}

export const logoutToken = async (): Promise<boolean> => {
  if (!isNewLoginActive()) return false

  try {
    const response = await fetch('/api/auth/logout', {
      method: 'POST',
      credentials: 'include',
    })
    if (!response.ok) throw new Error('Failed to logout')

    return true
  } catch (error) {
    console.error(error)
    return false
  }
}
